// **************************************************
import { Injectable } from '@angular/core';
import { UserApiService } from './user-api.service';
import { TaminServiceReturnModel } from '../models/electronic-prescription/tamin-service-return-model';
import { LoggerService } from 'src/app/services/logger.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { GetActivePrescriptionViewModel } from '../models/electronic-prescription/get-active-prescription-view-model';
import { Referral } from '../models/electronic-prescription/referral';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { PrescriptionDrug } from '../models/electronic-prescription/prescription-drug';
import { PrescriptionDrugStock } from '../models/electronic-prescription/prescription-drug-stock';
// **************************************************

@Injectable({
  providedIn: 'root',
})
export class TaminService {
  constructor(
    private calenderService: NewCalendarService,
    private apiService: UserApiService,
    private logger: LoggerService
  ) {}

  private APIToken?: string;

  public TaminLoginWithRedirect(): Promise<TaminServiceReturnModel> {
    return new Promise((resolve, reject) => {
      let notClose = false;

      let taminToken: TaminServiceReturnModel = new TaminServiceReturnModel();
      const url = `https://account-pilot.tamin.ir/auth/server/authorize?redirect_uri=${window.location.origin}/TaminAuthorizdetail&response_type=code&client_id=52325a1054023d5b2940111d541e2823&code_challenge=HFfKnXN93qrdavt_PbYq2GP56F_Unw06tl2b4IfzRnA&code_challenge_method=S256`;
      const w = 500;
      const h = 500;
      const popup = window.open(
        url,
        '_blank',
        'PopUp' +
          ',scrollbars=1,menubar=0,resizable=1,width=' +
          w +
          ',height=' +
          h +
          ',modal=yes'
      );

      const intervalId = setInterval(() => {
        if (notClose == false && (popup == null || popup.closed)) {
          reject('پنجره پاپ‌آپ بسته شد');
          clearInterval(intervalId);
          window.removeEventListener('message', popupListener);
        }
      }, 2000);

      const popupListener = (e) => {
        if (e.data.code) {
          try {
            notClose = true;
            const code = e.data.code;
            const redirect_uri = `${window.location.origin}/TaminAuthorizdetail`;
            this.apiService.GetTaminTocken(code, redirect_uri).subscribe(
              (result) => {
                taminToken.taminToken = result.access_token;
                taminToken.succeeded = true;
                resolve(taminToken);
              },
              (error) => {
                this.apiService.AddErrorLog(error);
                reject(error);
              },
              () => {}
            );
          } catch (e) {
            this.logger.addException(e, true);
            reject(e);
          }

          window.removeEventListener('message', popupListener);
        } else if (e.data.errorMessage) {
          this.logger.addError(e.data.errorMessage, false);
          reject(e.data.errorMessage);
          window.removeEventListener('message', popupListener);
        } else if (popup && popup.closed) {
          this.logger.addError(`خطا در ارتباط با سازمان تامین اجتماعی `, false);
          reject(`خطا در ارتباط با سازمان تامین اجتماعی `);
          window.removeEventListener('message', popupListener);
        }
      };

      window.addEventListener('message', popupListener);
    });
  }

  public GetPrescriptionVersionOne(
    nationalCode: string,
    trackingCode: string
  ): Promise<Referral> {
    return new Promise((resolve, reject) => {
      try {
        if (this.APIToken == '') {
          this.APIToken = undefined;
        }
        const backendUrl = `SaleElectronicPrescription/GetPrescription`;

        let backEndJson = new GetActivePrescriptionViewModel(0);

        backEndJson.nationalCode = nationalCode;
        backEndJson.trackingCode = trackingCode;
        backEndJson.token = this.APIToken;

        if (
          !this.apiService.tokenValidation(
            new ApiRequestModel(backendUrl, backEndJson)
          )
        ) {
          reject();
        }

        this.apiService
          .postItem(new ApiRequestModel(backendUrl, backEndJson))
          .subscribe(
            (result) => {
              if (result.succeeded == false) {
                this.logger.addBackEndMessage(result);
                reject(result);
                return;
              }

              var referral = this.mapResult(result.data);
              resolve(referral);
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              reject(error);
            }
          );
      } catch (error) {
        this.logger.addError(error, false);
        reject(error);
      }
    });
  }

  private mapResult(result: Referral) {
    this.APIToken = result.token;
    if (result.prescriptionDate != undefined) {
      result.prescriptionDate = this.calenderService.TaminToGregorian(
        result.prescriptionDate!
      );
    }

    result.prescriptions.forEach((prescription) => {
      prescription.drugs.forEach((drug) => {
        drug.stock.loading = true;
      });
    });

    return result;
  }

  public GetDrugDetailsVersionOne(
    drug: PrescriptionDrug
  ): Promise<PrescriptionDrugStock> {
    return new Promise((resolve, reject) => {
      try {
        const backendUrl = `SaleElectronicPrescription/Tamin/GetInventoryDrug?drugCode=${drug.genericCodeString}&count=${drug.requestCount}&isHospitalDrug=${drug.hospitalDrug == '1' ? true : false}&neededToHaveFile=${drug.neededToHaveFile == '1' ? true : false}&shouldSendToEsalat=${drug.shouldSendToEsalat}`;

        if (!this.apiService.tokenValidation(new ApiRequestModel(backendUrl))) {
          reject();
        }

        this.apiService
          .getSingleItem(new ApiRequestModel(backendUrl))
          .subscribe(
            (result) => {
              if (result.succeeded == false) {
                this.logger.addBackEndMessage(result);
                reject(result);
              }

              result.data.loading = false;
              resolve(result.data);
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              reject(error);
            }
          );
      } catch (error) {
        this.logger.addError(error, false);
        reject(error);
      }
    });
  }
}
